import React, { Component } from 'react'
import { Form, Grid, Image, Checkbox, Button, Icon } from 'semantic-ui-react'
import { connect } from 'react-redux'
import InputField from '../formComponents/inputField'
import SelecTextField from '../formComponents/selectTextField'
import { DropDown } from '../formComponents/dropDown'
import Images from '../config/images'
import * as actionCreators from '../actions'
import SearchFirmList from '../formComponents/searchFirmList'
import { bolAwbFields } from '../util/supportedFields/bolAwbForm'
import _, { get} from 'lodash'
import { saveContainer } from '../api/setFormData'
import PscHeaderReason from "./headerReason";
import {fetchSelectedReasonCodes, totalHeaderReasonSelected} from "../util";
//import {QryFuncModal} from '../../components/qryFunc';
import {QryFuncModal} from 'kx-common-components';
import { displayMasterItem } from './util/index'
export class BolAwbForm extends Component {
  constructor() {
    super()
    this.state = {
      formInfo: {}
    }
    for (let key in bolAwbFields) {
      bolAwbFields[key].errors = []
      bolAwbFields[key].valid = []
    }
    this.addErrorClass.bind(this)
    this.removeErrorClass.bind(this)
    this.handleContainerSave.bind(this)
    this.addErrorIcon.bind(this)
    this.removeErrorIcon.bind(this)
  }

  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
  }

  addErrorIcon(fieldName, value, msg) {
    bolAwbFields[fieldName].errors = []
    bolAwbFields[fieldName].valid = false
    bolAwbFields[fieldName].errors.push(msg)
    this.props.updateBolErrorWarning(1)
  }

  removeErrorIcon(fieldName, value) {
    bolAwbFields[fieldName].errors = []
    bolAwbFields[fieldName].valid = true
    this.props.updateBolErrorWarning(0)
  }

  // Check field Validity
  validateField(fieldName, value) {
    let warning = 0
    const newState = Object.assign({}, this.state)
    newState.formInfo[fieldName] = value
    this.setState(newState)
    bolAwbFields[fieldName].errors = []
    bolAwbFields[fieldName].valid = true
    if (
      bolAwbFields[fieldName].rules &&
      bolAwbFields[fieldName].rules.length > 0
    ) {
      bolAwbFields[fieldName].rules.forEach(rule => {
        console.log(rule.test(value))
        if (!rule.test(value)) {
          bolAwbFields[fieldName].errors.push(rule.message)
          bolAwbFields[fieldName].valid = false
        }
      })
    }
    Object.keys(bolAwbFields).forEach(field => {
      if (!bolAwbFields[field].valid) {
        warning++
      }
    })
    this.props.updateBolErrorWarning(warning)
    if (bolAwbFields[fieldName].errors.length) {
      this.addErrorClass(fieldName, bolAwbFields)
    } else {
      this.removeErrorClass(fieldName, bolAwbFields)
    }
  }

  handleContainerSave(index, id, type, value,containerNumber) {
    saveContainer(id, type, value,containerNumber)
      .then(res => {
        let newContainerId = _.get(res, 'data.eventMessage.bolInfo.container[0].containerId', null)

        if (_.get(res, 'data.eventMessage.code') !== 200 && !newContainerId) {
          try {
            this.addErrorClass(`${type}${index}`)
            //let msg = 'Container number was invalid. The value was not saved, please amend.'
            this.addErrorIcon(`number${index}`, value, _.get(res, 'data.eventMessage.msg'))
          } catch (e) { }
        } else {
          try {
            this.removeErrorClass(`${type}${index}`)
            this.removeErrorIcon(`number${index}`, value)
          } catch (e) { }
        }
        // If a new contianer was saved, res will come with ID and we should resave it so UI is in sync
        if (newContainerId) {
          this.props.updateContainer(index, 'containerId', newContainerId)
        }
      })
  }

  addErrorClass(fieldName, fieldType) {
    console.log('fieldName1', fieldName)
    const inputField = document.getElementById(fieldName + window.shipmentId)
    inputField.classList.add('errorInput')
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.getElementById(fieldName + window.shipmentId)
      inputField.classList.remove('errorInput')
    } catch (e) {
      console.error(e)
    }
  }

  // Dispaly Errors
  displayValidationErrors = fieldName => {
    const field = bolAwbFields[fieldName]
    if (field && !field.valid) {
      const errors = field.errors.map((info, index) => {
        return (
          <span className='error' key={index}>
            * {info}
          </span>
        )
      })

      return <div style={{ position: 'absolute' }}>{errors}</div>
    }
    return null
  }
  enableDisableFrom = (enableForm) => {
    this.setState({
      "enableForm": enableForm
    })
  }
  render() {
    let {
      bolInfoValues,
      updateBOLInfoField,
      updateContainer,
      removeAdditionalContainer,
      saveBOLInfoField,
      saveContainer,
      manifestQuantityQuantity,
      manifestQuantityUnits,
      updateBOLObject,
      updateTransportationField,
      saveTransportationField,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      unitList,
      bolTypeList,
      // SCACList,
      USportOfUnladingCode,
      formDisabled,
      rbCounterID,
      updateITDateField,
      isDisabled,
      addContainer,
      modeOfTransport,
      saveHeaderReason,
      fieldValidation,
    } = this.props

    const splitShipmentFields = [
      {id:'0', value: '0', description: 'None', hidePrefixOnOption: true},
      {id:'1', value: '1', description: 'Hold All - Release Entry when all cargo qualifies'},
      {id:'2', value: '2', description: 'Incremental - Request incremental cargo release. Entry date will be when the first portion is released'},
    ];

    let pscWarningAlertShow = this.selectedReasons.length<=0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')

    // let totalHeaderReasonSelected = this.props.pscData.headerCodes ? this.props.pscData.headerCodes.map((item)=>{
    //   return item.reasonCodes ? item.reasonCodes.length : 0
    // }).reduce((a, b) => a + b, 0) : 0;
    let truuck = modeOfTransport=="TRUCK";
    return (
      <Form title={pscWarningAlertShow?"Must select a PSC reason before you can edit":""}>
        {
        (get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) && 
          <PscHeaderReason 
          {...this.props} 
          pscState={get(this.props, "pscState.value.state")}
          totalHeaderReasonSelected={totalHeaderReasonSelected(this.props.pscData)}
          selectedOptions={this.selectedReasons}
          saveHeaderReason={saveHeaderReason} 
          enableDisableFrom={this.enableDisableFrom}/>
        }
        <Grid width='equal' className='no-gutters'>
          <Grid.Row>
            <Grid.Column width={'4'}>
              <Checkbox
                id={bolAwbFields.nonAms.id}
                disabled={this.state.enableForm === true ? false : isDisabled(bolAwbFields.nonAms.id)}
                label={bolAwbFields.nonAms.label}
                shipmentId={shipmentId}
                checked={bolInfoValues.nonAms === 1}
                onChange={() => {
                  updateBOLInfoField(
                    bolAwbFields.nonAms.id,
                    bolInfoValues.nonAms === 1 ? 2 : 1
                  )
                }}
                onBlur={() => saveBOLInfoField(bolAwbFields.nonAms.id)}
              />
            </Grid.Column>
            <Grid.Column width={'4'}>
              
              <DropDown
                id={bolAwbFields.splitBill.id}
                label={ "Split Shipment"}
                disabled={this.state.enableForm === true ? false : isDisabled(bolAwbFields.splitBill.id)}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={splitShipmentFields}
                shipmentId={shipmentId}
                text={displayMasterItem(bolInfoValues.splitBill+"", splitShipmentFields)}
                onChange={value => {
                  updateBOLInfoField(
                    bolAwbFields.splitBill.id,
                    value
                  )
                  saveBOLInfoField('splitBill', value)
                }}
              />

            </Grid.Column>
           {
              bolInfoValues.bol.bolnumber && 
                <Grid.Column width={'8'}>
                  <div className="uUiil ADCVDbutton broker-top-header">
                    <QryFuncModal 
                      adminAccountReadonly={window.typeOfUser === "BROKER_KN_ADMIN"}
                      brokerId={window.brokerId}
                      launchFrom={'BOL_FORM'}
                      hideLeftPanel={true}
                      dataType={"BOL"}
                      width={"75%"}
                      value={modeOfTransport=="TRUCK" ? bolInfoValues.bol.bolnumber : (bolInfoValues.bol.bolHouseNumber ?bolInfoValues.bol.bolHouseNumber.toUpperCase(): '')}
                      bolNum={modeOfTransport=="TRUCK" ? bolInfoValues.bol.bolnumber : (bolInfoValues.bol.bolHouseNumber ?bolInfoValues.bol.bolHouseNumber.toUpperCase(): '')}
                      mBol={bolInfoValues.bol.bolnumber ?bolInfoValues.bol.bolnumber.toUpperCase(): ''}
                      buttontext={"RUN BOL QUERY"}
                      recentQryCall={false}
                      mot={modeOfTransport}
                      shipId={shipmentId}
                      baseUrl={window._env_.REACT_APP_BROKER_API_URL}
                  /></div>
                </Grid.Column>
            }
          </Grid.Row>
          <Grid.Row>
          </Grid.Row>
          <Grid.Row className='fourColoumnMerge blk2'>
            <Grid.Column width={'4'} className='firstCol'>
              <DropDown
                id={bolAwbFields.boltype.id}
                label={ truuck?'PAPS TYPE':bolAwbFields.boltype.label}
                disabled={true || Boolean(formDisabled)}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={bolTypeList}
                shipmentId={shipmentId}
                errors={bolAwbFields[bolAwbFields.boltype.id].errors}
                text='MASTER'
                onChange={value => {
                  updateBOLObject('bol', bolAwbFields.boltype.id, value)
                  saveBOLInfoField('bol')
                }}
              />
            </Grid.Column>
            <Grid.Column
              width={'5'}
              className='secondCol secColn no-field-margin'
            >
              <InputField
                isLabel={false}
                id={bolAwbFields.bolnumber.id}
                disabled={this.state.enableForm === true ? false : isDisabled(bolAwbFields.bolnumber.id)}
                type='text'
                label={truuck?'PAPS NUMBER':bolAwbFields.bolnumber.label}
                className='field-bg'
                errors={bolAwbFields[bolAwbFields.bolnumber.id].errors}
                value={bolInfoValues.bol.bolnumber}
                maxlength={modeOfTransport === 'AIR' ? 12 : 16}
                onChange={value => updateBOLObject('bol', bolAwbFields.bolnumber.id, value)}
                onBlur={value => {
                  this.validateField(bolAwbFields.bolnumber.id, value)
                  saveBOLInfoField('bol')
                  // Match scac on master and set it if found
                  let scac = value.match(/^[a-zA-Z]{4}/)
                  if (scac) {
                    let scacCode = scac[0].toUpperCase()
                    updateTransportationField('vesselCode', scacCode)
                    saveTransportationField('vesselCode', scacCode)
                  } else {
                    updateTransportationField('vesselCode', '')
                    saveTransportationField('vesselCode', '')
                  }
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                clearInput={true}
              />
              {/* {this.displayValidationErrors('bolnumber')} */}
            </Grid.Column>
            <Grid.Column
              width={'4'}
              className='lastCol quantity-padding no-field-margin'
            >
              <SelecTextField
                id={bolAwbFields['manifestQuantity.Quantity'].id}
                inputName='manifestQuantity.Quantity'
                selectName='manifestQuantity.Units'
                isLabel={false}
                disabled={this.state.enableForm === true ? false : isDisabled('manifestQuantity.Quantity')}
                type='text'
                label={bolAwbFields['manifestQuantity.Quantity'].label}
                width='16'
                divClassName='white'
                errors={
                  fieldValidation?.validObjects_bl[
                    `Bolqwqr${"manifestQuantityUnits"}`
                  ]
                }
                textfieldSize={16}
                className='field-bg'
                options={unitList.filter(a=>a.id!="NONE")}
                value={manifestQuantityQuantity}
                dropDownValue={manifestQuantityUnits}
                updateValue={value => {
                  updateBOLObject(
                    'manifestQuantity',
                    'quantity',
                    value.replace(/[^\d.-]/g, '')
                  )
                }}
                updateDropDownValue={value => {
                  updateBOLObject('manifestQuantity', 'units', value)
                  this.validateField(bolAwbFields['manifestQuantity.Units'].id, value)
                }}
                onBlur={value => {
                  this.validateField(bolAwbFields['manifestQuantity.Quantity'].id, value)
                  if (value && !!manifestQuantityQuantity) {
                    updateBOLObject('manifestQuantity', 'quantity',
                      parseFloat(manifestQuantityQuantity).toFixed(2)
                    )
                  }
                  saveBOLInfoField('manifestQuantity')
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
              {/* {this.displayValidationErrors('manifestQuantity.quantity')}
              {this.displayValidationErrors(bolAwbFields.manifestQuantityUnits.label)} */}
            </Grid.Column>
          </Grid.Row>
          {/* START HOUSE BOL ROW!*/}
          <React.Fragment>
          {bolInfoValues.bol.boltype !== 'HOUSE_BOL' && modeOfTransport!='TRUCK' && ( 
            <div className='blk6 add-house'>
              <a
                className='addMoreBut'
                onClick={() => {
                  if (this.state.enableForm === false){
                    if(isDisabled(bolAwbFields.bolHouseNumber.id)){
                      return;
                    }
                  }
                  updateBOLObject('bol', bolAwbFields.boltype.id, 'HOUSE_BOL')
                  saveBOLInfoField('bol')
                }}
              >
                <Image src={Images.pluseWhite} />
                Add House BOL
              </a>
            </div>
          )}
          {bolInfoValues.bol.boltype === 'HOUSE_BOL' && (
            <Grid.Row className='fourColoumnMerge blk2'>
              <i
                style={{ marginLeft: '15px', top: '10px' }}
                className='trash alternate outline icon'
                onClick={() => {
                  setTimeout(()=>{
                    document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click()
                  },50)
                  if (this.state.enableForm === false){
                    if(isDisabled(bolAwbFields.bolHouseNumber.id)){
                      return;
                    }
                  }
                  updateBOLObject('bol', bolAwbFields.boltype.id, 'MASTER_BOL')
                  updateBOLObject('bol', bolAwbFields.bolHouseNumber.id, '_BLANK_')
                  saveBOLInfoField('bol')
                }}
              />
              <Grid.Column width={'4'} className='firstCol'>
                <DropDown
                  id={bolAwbFields.boltype.id}
                  label={bolAwbFields.boltype.label}
                  disabled={true || Boolean(formDisabled)}
                  className='field-bg dropdown100'
                  labelClass='text-none'
                  shipmentId={shipmentId}
                  isLabel={true}
                  data={bolTypeList}
                  errors={bolAwbFields[bolAwbFields.boltype.id].errors}
                  text={'HOUSE'}
                  onChange={value => {
                    updateBOLObject('bol', bolAwbFields.boltype.id, value)
                    saveBOLInfoField('bol')
                  }}
                />
              </Grid.Column>
              <Grid.Column width={'5'} className='secondCol'>
                <InputField
                  isLabel={false}
                  id={bolAwbFields.bolHouseNumber.id}
                  disabled={this.state.enableForm === true ? false : isDisabled(bolAwbFields.bolHouseNumber.id)}
                  type='text'
                  label={bolAwbFields.bolHouseNumber.label}
                  className='field-bg'
                  maxlength={modeOfTransport === 'AIR' ? 12 : 16}
                  value={bolInfoValues.bol.bolHouseNumber}
                  onChange={value =>
                    updateBOLObject('bol', bolAwbFields.bolHouseNumber.id, value)
                  }
                  onBlur={value => saveBOLInfoField('bol')}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                  clearInput={true}
                />
              </Grid.Column>
              <Grid.Column width={'4'} className='lastCol'>
                <SelecTextField
                  inputName='manifestQuantity.quantity'
                  selectName='manifestQuantity.units'
                  isLabel={false}
                  disabled={true || Boolean(formDisabled)}
                  type='text'
                  label={bolAwbFields['manifestQuantity.Quantity'].label}
                  divClassName='white'
                  placeholder=''
                  width='16'
                  textfieldSize={16}
                  className='field-bg'
                  options={unitList}
                  value={manifestQuantityQuantity}
                  dropDownValue={manifestQuantityUnits}
                  updateValue={value => {
                    updateBOLObject(
                      'manifestQuantity',
                      'quantity',
                      value.replace(/[^\d.-]/g, '')
                    )
                  }}
                  updateDropDownValue={value => {
                    updateBOLObject('manifestQuantity', 'units', value)
                  }}
                  onBlur={value => {
                    if (value && !!manifestQuantityQuantity) {
                      updateBOLObject(
                        'manifestQuantity',
                        'quantity',
                        parseFloat(manifestQuantityQuantity).toFixed(2)
                      )
                    }
                    saveBOLInfoField('manifestQuantity')
                  }}
                  newValue={newValue}
                  fieldName={fieldName}
                  setINPUTID={setINPUTID}
                  penClicked={penClicked}
                  shipmentId={shipmentId}
                  rbCounterID={rbCounterID}
                />
              </Grid.Column>
            </Grid.Row>
          )}
          
          </React.Fragment>
  
          {/* END HOUSE BOL ROW!*/}

          <br />
          {
            modeOfTransport !== 'AIR'
            && (<>
              <h4 style={{ width: '100%' }}>CONTAINERS</h4>
              <React.Fragment>
                {bolInfoValues.container.map((container, index) => {
                  let redundantContainerId = false;
                  (bolInfoValues.container||[]).forEach((existingcontainer,xindex) => {
                    if((existingcontainer.number+"").toLowerCase().trim() == (container.number+"").toLowerCase().trim() && xindex < index){
                      redundantContainerId=true;
                    }});
                  
                  return(
                  
                  <Grid.Row
                    key={index + '-' + container}
                    className='fourColoumnMerge blk1'
                  >
                    <i
                      style={{ marginLeft: '15px', top: '10px' }}
                      className={
                        bolInfoValues.container.length === 1
                          ? 'trash alternate outline icon hide-element'
                          : 'trash alternate outline icon'
                      }
                      disabled={this.state.enableForm === true ? false : isDisabled("removeContainer")}
                      onClick={() => {
                        // if (formDisabled) {
                        //   return
                        // }
                        removeAdditionalContainer(index)
                      }}
                    />
                    <Grid.Column width={'4'} className='firstCol no-field-margin'>
                      <InputField
                        isLabel={false}
                        id={`number${index}`}
                        disabled={this.state.enableForm === true ? false : isDisabled("containerNo")}
                        type='text'
                        label='Container #'
                        labelClassName='city'
                        className='field-bg'
                        errors={_.get(bolAwbFields, `[number${index}].errors`,[]).concat(redundantContainerId?[`Duplicate Container Number '${container.number}'! Please only have one line per Container Number.`]:[])}
                        value={container.number}
                        onChange={value => {
                          updateContainer(index, 'number', value.replace(/[\W_]+/g, ""))
                        }}
                        onBlur={value => {
                          this.validateField(`number${index}`, value)
                          if (
                            bolAwbFields[`number${index}`] &&
                            bolAwbFields[`number${index}`].valid &&
                            !redundantContainerId
                          ) {
                            this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'number', value, value)
                          }
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                      {/* {this.displayValidationErrors(`number${index}`)} */}
                    </Grid.Column>
                    <Grid.Column width={'3'} className='secondCol no-field-margin'>
                      <InputField
                        // isLabel={false}
                        id={`size${index}`}
                        value={container.size}
                        className='field-bg'
                        labelClass='text-none'
                        label='Size'
                        disabled={
                          redundantContainerId || (
                          this.state.enableForm === true ? false : (isDisabled('containerSize')
                        || !bolAwbFields[`number${index}`]
                        || !bolAwbFields[`number${index}`].valid))}  
                        errors={_.get(bolAwbFields, `[size${index}].errors`)}
                        onChange={value => {
                          updateContainer(index, 'size', value.replace(/[\W_]+/g, ""))
                        }}
                        onBlur={value => {
                          this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'size', value,container.number)
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                      {/* {this.displayValidationErrors(`size${index}`)} */}
                    </Grid.Column>
                    <Grid.Column width={'3'} className='thirdCol no-field-margin'>
                      <InputField
                        isLabel={false}
                        id={`sealNumber${index}`}
                        disabled={
                          redundantContainerId || (this.state.enableForm === true ? false : isDisabled("sealNumber"))
                        }
                        type='text'
                        label='Seal Number'
                        labelClassName='city'
                        className='field-bg'
                        errors={_.get(bolAwbFields, `[sealNumber${index}].errors`)}
                        value={container.sealNumber}
                        onChange={value => {
                          updateContainer(index, 'sealNumber', value)
                        }}
                        onBlur={value => {
                          this.validateField(`sealNumber${index}`, value)
                          if (
                            bolAwbFields[`sealNumber${index}`] &&
                            bolAwbFields[`sealNumber${index}`].valid
                          ) {
                            this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'sealNumber', value,container.number)
                          }
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                      {/* {this.displayValidationErrors(`number${index}`)} */}
                    </Grid.Column>
                    <Grid.Column width={'2'} className='thirdCol no-field-margin'>
                      <InputField
                        isLabel={false}
                        id={`quantity${index}`}
                        disabled={
                          redundantContainerId || (this.state.enableForm === true ? false : isDisabled("quantity"))
                        }
                        type='text'
                        label='Quantity'
                        labelClassName='city'
                        className='field-bg'
                        errors={_.get(bolAwbFields, `[quantity${index}].errors`)}
                        value={container.quantity}
                        onChange={value => {
                          updateContainer(index, 'quantity', value)
                        }}
                        onBlur={value => {
                          this.validateField(`quantity${index}`, value)
                          if (
                            bolAwbFields[`quantity${index}`] &&
                            bolAwbFields[`quantity${index}`].valid
                          ) {
                            this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'quantity', value,container.number)
                          }
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                      {/* {this.displayValidationErrors(`weight${index}`)} */}
                    </Grid.Column>
                    <Grid.Column width={'2'} className='lastCol no-field-margin'>
                      <InputField
                        isLabel={false}
                        id={`weight${index}`}
                        disabled={
                          redundantContainerId || (
                            this.state.enableForm === true ? false : isDisabled("weight")
                          )}
                        type='text'
                        label='Weight'
                        labelClassName='city'
                        className='field-bg'
                        errors={_.get(bolAwbFields, `[weight${index}].errors`)}
                        value={container.weight}
                        onChange={value => {
                          updateContainer(index, 'weight', value)
                        }}
                        onBlur={value => {
                          this.validateField(`weight${index}`, value)
                          if (
                            bolAwbFields[`weight${index}`] &&
                            bolAwbFields[`weight${index}`].valid
                          ) {
                            this.handleContainerSave(index, bolInfoValues.container[index].containerId, 'weight', value,container.number)
                          }
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                        clearInput={true}
                      />
                      {/* {this.displayValidationErrors(`weight${index}`)} */}
                    </Grid.Column>
                  </Grid.Row>
                )})}
              </React.Fragment>

              <Grid.Column>
                <Button style={{display:'none'}}></Button>
                <Button
                  className={'add-line-item-btn add-cont'}
                  basic
                  color='blue'
                  circular
                  compact
                  onClick={() => {
                    // createContainer(bolInfoValues.container.length)
                    addContainer({
                      number: "",
                      size: "",
                      containerId: ""
                    })
                  }}
                  disabled={this.state.enableForm === true ? false : isDisabled('addContainer')}
                >
                  <span>
                    <Icon name='add circle' /> Add Additional Container
                    </span>
                </Button>
              </Grid.Column>
            </>)}
        </Grid>
        <br />
      </Form>
    )
  }
}

const mapStateToProps = state => ({
  bolInfoValues: state.BOLInfo,
  unitList: state.DropDownValues.unitList,
  bolTypeList: state.DropDownValues.bolTypeList,
  // SCACList: state.DropDownValues.SCACList,
  manifestQuantityQuantity: state.BOLInfo.manifestQuantity.quantity,
  manifestQuantityUnits: state.BOLInfo.manifestQuantity.units,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  shipmentId: state.FormValues.shipmentId,
  USportOfUnladingCode: state.TransportationInfo.USportOfUnladingCode,
  formDisabled: state.FormValues.formDisabled,
  rbCounterID: state.FormValues.rbCounterID,
  fieldValidation: state.FieldValidation,
  tabName: "bolAwb",
  pscData: state.PSC
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BolAwbForm)
